import React from 'react';
import {useTranslation} from 'react-i18next';
import {FormProvider, useForm} from 'react-hook-form';
import {useGuest, useScreenResize} from '../../hooks';
import {useGetGuestId} from '../../hooks/useGetGuestId';
import {device} from '@guestapp/ui/src/utils/device';
import {SessionStorage} from '@guestapp/core';
import {STORAGE_KEYS} from 'utils/constants';
import {SDK_MODE} from 'utils/embedded';
import {FORM_NAMES, FormTypes} from 'utils/guestForm';
import {useSchema} from 'context/guest';
import GuestFormFields from 'components/GuestFormFields';
import {Page} from 'components/Page/Page';
import {AutoFill} from './AutoFill';
import {WhyDataRequired} from 'components/WhyDataRequired';
import {FormWrapper, Title, Wrapper} from './styled';

function AddPersonalDataForm() {
  const {t} = useTranslation();
  const {customFormsVersion} = useSchema();
  const {isMatch: isMobileMode} = useScreenResize(device.tabletSubHeader);
  const [errorModal, setErrorModal] = React.useState(false);
  const isValidateKeyboard = isMobileMode && errorModal;
  const guestId = useGetGuestId();
  const {guest} = useGuest({id: guestId});
  const methods = useForm({
    shouldFocusError: !isValidateKeyboard,
    defaultValues: {
      [FORM_NAMES.residence_city]: null,
      [FORM_NAMES.birth_place_city]: null,
      [FORM_NAMES.document_expedition_city]: null,
    },
  });
  const hasPersistedData = Boolean(
    SessionStorage.get<FormTypes>(STORAGE_KEYS.personalFormData),
  );
  const isAutoFillingAvailable = !hasPersistedData && !Boolean(guest?.id);

  return (
    <Page
      isSubHeaderVisible={window.ChekinProSettings?.mode !== SDK_MODE.onlyGuestForm}
      title={t('guest_data')}
      isBackButtonDisabled
      navBarTitle={isMobileMode ? t('guest_data') : t('online_chekin')}
      className="guest-form"
    >
      <Wrapper className="guest-form__header">
        <Title className="guest-form__title">{t('enter_your_personal_data')}</Title>
        {customFormsVersion === 'V1' && <WhyDataRequired />}
        {isAutoFillingAvailable && <AutoFill />}
      </Wrapper>
      <FormProvider {...methods}>
        <FormWrapper>
          <GuestFormFields setErrorModal={setErrorModal} />
        </FormWrapper>
      </FormProvider>
    </Page>
  );
}

export {AddPersonalDataForm};
